<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const isWidePage = computed(() =>
  ['report_schedules', 'queued_customers_reports', 'bot_reports'].includes(
    route.name
  )
);
</script>

<template>
  <div class="overflow-auto bg-n-surface-1 w-full px-6">
    <div class="mx-auto pb-12" :class="isWidePage ? 'max-w-7xl' : 'max-w-5xl'">
      <router-view />
    </div>
  </div>
</template>
